<template>
  <q-page padding>
    <div class="row col-12">
      <p class="text-h6 text-brand-5 text-weight-bold">
        Liberação antes do prazo mínimo
      </p>
    </div>
    <div class="row col-md-2 q-mt-md">
      <div class="col-md-2">
        <lista-unidades-select v-model="unidade" />
      </div>
      <div class="col-md-2 q-ml-sm">
        <q-select
          outlined
          dense
          v-model="usuario"
          :options="listaUsuarios"
          option-value="id"
          label="Selecione o Usuario"
          behavior="menu"
          map-options
          use-input
          option-label="name"
          @filter="filterUser"
        >
        </q-select>
      </div>
    </div>

    <table-grupos class="q-mt-lg" />
    <section>
      <q-table
        flat
        table-header-class="bg-accent text-width-bold"
        :rows="rows"
        dense
        :loading="disable"
        :columns="columns"
        v-model:pagination="pagination"
        no-data-label="Sem dados"
        class="q-mt-md tabela-tamanho-fixo"
        row-key="name"
        hide-pagination
        @request="handleRequest"
      >
        <template v-slot:top-right>
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            v-model="filtrar"
            type="text"
            placeholder="Pesquisar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </template>

        <template #body-cell-group_id="props">
          <q-td>
            <div>
              <q-btn
                round
                :disable="
                  !compararData(
                    props.row.dias_para_retirada,
                    props.row.quantidade_retirada,
                    props.row.quantidade_total_regra
                  )
                "
                :color="
                  compararData(
                    props.row.dias_para_retirada,
                    props.row.quantidade_retirada,
                    props.row.quantidade_total_regra
                  )
                    ? 'positive'
                    : 'grey'
                "
                :icon="
                  compararData(
                    props.row.dias_para_retirada,
                    props.row.quantidade_retirada,
                    props.row.quantidade_total_regra
                  )
                    ? 'done'
                    : 'done'
                "
                @click="liberar(props.row.group_id)"
              />
            </div>
          </q-td>
        </template>
        <template #body-cell-ultima_retirada="props">
          <q-td>
            <span v-if="props.row.ultima_retirada">{{
              props.row.ultima_retirada
                .split(" ")[0]
                .split("-")
                .reverse()
                .join("/")
            }}</span>

            <span class="q-ml-sm" v-if="props.row.ultima_retirada">{{
              props.row.ultima_retirada.split(" ")[1]
            }}</span>
          </q-td>
        </template>
        <template #body-cell-prazo_minimo="props">
          <q-td>
            <span v-if="props.row.prazo_minimo">{{
              props.row.prazo_minimo
                .split(" ")[0]
                .split("-")
                .reverse()
                .join("/")
            }}</span>

            <span class="q-ml-sm" v-if="props.row.prazo_minimo">{{
              props.row.prazo_minimo.split(" ")[1]
            }}</span>
          </q-td>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          @update:model-value="handleRequest"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="true"
          :direction-links="true"
          size="sm"
        />
      </div>
    </section>
  </q-page>
</template>

<script>
import { ref, onMounted, computed, watch } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { useQuasar } from "quasar";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import { usuarioTemPermissao } from "../../../../helpers/permissaoHelper";
const columns = [
  {
    name: "grupo_nome",
    label: "Grupo",
    field: "grupo_nome",
    align: "left",
  },
  {
    name: "tipo",
    label: "Tipo Associação",
    field: "tipo",
    align: "left",
  },
  {
    name: "ultima_retirada",
    label: "Ultima Retirada",
    field: "ultima_retirada",
    align: "left",
  },
  {
    name: "prazo_minimo",
    label: "	Próxima Retirada",
    field: "prazo_minimo",
    align: "left",
  },
  {
    name: "quantidade_total_regra",
    label: "	Qtd. Máx",
    field: "quantidade_total_regra",
    align: "left",
  },
  {
    name: "quantidade_retirada",
    label: "Já Retirou",
    field: "quantidade_retirada",
    align: "left",
  },
  {
    name: "group_id",
    label: "Liberar",
    field: "group_id",
    align: "left",
  },
];
export default {
  components: { ListaUnidadesSelect },
  setup() {
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 20,
      rowsNumber: 0,
    });
    const maxPage = ref(1);
    const unidade = ref();
    const rows = ref([]);
    const disable = ref(false);
    const store = useStore();
    const route = useRoute();
    const quasar = useQuasar();

    const filtrar = ref("");
    const time = ref();
    const listaUsuarios = ref([]);

    const usuario = ref();
    const data = ref({ dataAtual: "", horaAtual: "" });

    const id = route.params.id;

    const temPermissaoTodosUsuarios = computed(() =>
      usuarioTemPermissao(store, "visualizar_todos_usuários")
    );

    const getGrupos = async (page = 1, rowsPerPage = 20) => {
      disable.value = true;

      if (usuario.value == null) {
        disable.value = false;
        return;
      }
      try {
        let response = await store.dispatch("user/getProdutosGrupos", {
          id: usuario.value.id,
          page,
          per_page: rowsPerPage,
          search: filtrar.value,
        });

        rows.value = response.data.result.data;

        const currentPage = Number(response.data.result.current_page) || 1;
        const hasNextPage = !!response.data.result.next_page_url;

        pagination.value.rowsPerPage =
          Number(response.data.result.per_page) || rowsPerPage;
        pagination.value.page = currentPage;

        // API usa simplePaginate (sem campo total), então descobrimos as páginas
        // progressivamente via next_page_url ao navegar
        const discoveredMax = currentPage + (hasNextPage ? 1 : 0);
        if (discoveredMax > maxPage.value) {
          maxPage.value = discoveredMax;
        }

        disable.value = false;
      } catch (error) {
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const listarUsuarios = async (value) => {
      try {
        // se tiver permissão de ver todos, envia vendor_id vazio para listar todo o tenant
        const vendorId = temPermissaoTodosUsuarios.value
          ? undefined
          : unidade.value?.id || store.state.org.unidadeData?.id || undefined;

        let response = await store.dispatch("user/getUsuarios", {
          vendor_id: vendorId,
          per_page: 10,
          search: value,
        });

        listaUsuarios.value = response.data.results.data;
      } catch (error) {
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };
    onMounted(listarUsuarios);

    const handleRequest = async () => {
      getGrupos(pagination.value.page, pagination.value.rowsPerPage);
    };

    watch(
      () => filtrar.value,
      () => {
        pagination.value.page = 1;
        maxPage.value = 1;
        handleRequest();
      }
    );

    watch(
      () => usuario.value,
      () => {
        pagination.value.page = 1;
        maxPage.value = 1;
        handleRequest();
      }
    );

    const removerGrupo = async (group_id) => {
      try {
        await store.dispatch("user/removerGrupo", {
          id,
          group_id,
        });

        quasar.notify({
          message: "Grupo removido com sucesoo",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getGrupos(1, pagination.value.rowsPerPage);
      } catch (error) {
        quasar.notify({
          message: "Erro ao remover grupo",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const liberar = async (group) => {
      try {
        await store.dispatch("user/liberarPrazo", {
          user_id: usuario.value.id,
          group_id: group,
        });

        quasar.notify({
          message: "Prazo liberado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getGrupos(pagination.value.page, pagination.value.rowsPerPage);
      } catch (error) {
        quasar.notify({
          message: "Erro ao liberar prazo",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const gerarDataAtual = () => {
      let dataAtual = new Date();

      let mesAtual = dataAtual.getMonth() + 1;
      let diaAtual = dataAtual.getDate();
      let anoAtual = dataAtual.getFullYear();

      let horaAtual = dataAtual.getHours();
      let minutoAtual = dataAtual.getMinutes();
      let secundoAtual = dataAtual.getSeconds();

      data.value.dataAtual = diaAtual + "-" + mesAtual + "-" + anoAtual;
      data.value.horaAtual = horaAtual + ":" + minutoAtual + ":" + secundoAtual;
    };

    onMounted(gerarDataAtual);

    const compararData = (
      dias_para_retirada,
      quantidade_retirada,
      quantidade_total_regra
    ) => {
      if (dias_para_retirada == null) {
        return false;
      }

      //const hoje = new Date();
      // const prazoMinimoDate = new Date(prazo_minimo)

      if (
        dias_para_retirada > 0 &&
        quantidade_total_regra <= quantidade_retirada
      ) {
        return true;
      } else {
        return false;
      }
    };

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value = JSON.parse(getunidade);
      }
    };

    onMounted(getUnidade);

    return {
      unidade,
      columns,
      rows,
      pagination,
      disable,
      getGrupos,
      pagesNumber: computed(() => maxPage.value),
      handleRequest,
      removerGrupo,
      filtrar,
      liberar,
      data,
      gerarDataAtual,
      filterUser(val, update) {
        clearTimeout(time.value);

        time.value = setTimeout(() => {
          listarUsuarios(val);
        }, 2000);

        setTimeout(() => {
          update();
        }, 2500);
      },
      listaUsuarios,
      usuario,
      compararData,
    };
  },
};
</script>
